module.exports = __webpack_public_path__ + "static/media/Chang-Zi-Qian.19963410.png";